import React from "react";
import { Nav } from "react-bootstrap";

const StatusTabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["All", "Report Available", "For Checking", "For Adjustment", "Submitted", "Accepted", "Rejected"];

  return (
    <Nav variant="tabs" activeKey={activeTab} onSelect={setActiveTab}>
      {tabs.map((tab) => (
        <Nav.Item key={tab}>
          <Nav.Link eventKey={tab}>{tab}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default StatusTabs;
